export default {
    votes: [],
};
